import React, { Fragment } from 'react';

import useMyLscOtsMeetSearchContextView from './UseMyLscOtsMeetSearchContextView';

import LeftArrowIcon from '@usas/ui-web/components/icons/LeftArrowIcon';
import Headings from '@usas/ui-web/components/headings/Headings';
import PageNotFound from '@usas/ui-web/components/PageNotFound';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const MyLscOtsMeetSearchContextView = ({ children }) => {
  const {
    selectOrgUnitState,
    onHomeClicked,
    onBackToSelectionClicked
  } = useMyLscOtsMeetSearchContextView();


  if (!selectOrgUnitState.orgUnitId) {
    return (
      <Fragment>
        <div className="row usas-extra-bottom-margin">
          <div className="col-xs-12">
            <button className={global.BackToSearchButton}
              type="button"
              onClick={onBackToSelectionClicked}>
              <LeftArrowIcon />  Back to Selection
            </button>
          </div>
        </div>
        <div className="row usas-extra-bottom-margin">
          <div className="col-xs-12">
            <PageNotFound />
          </div>
        </div>
      </Fragment>)
  }

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <button className={global.HeaderButton} onClick={onHomeClicked}>
            <Headings.H3
              className={[global.NoBottomMargin, 'col-xs-12'].join(' ')}
              excludeBar={true}>
              My LSC OTS Meet Search
            </Headings.H3>
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12">
          <hr className="usas-bar-turmeric" />
        </div>
      </div>
      {selectOrgUnitState.showBackToSelection &&
        <div className="row">
          <div className="col-xs-12">
            <button className={global.BackToSearchButton}
              type="button"
              onClick={onBackToSelectionClicked}>
              <LeftArrowIcon />  Back to Selection
            </button>
          </div>
        </div>}
      <div className="row usas-extra-bottom-margin">
        <div className="col-xs-12">
          <p className={global.HeaderText}><strong>LSC:</strong> {selectOrgUnitState.orgUnitName}</p>
        </div>
      </div>
      {children}
    </Fragment>
  );
};

export default MyLscOtsMeetSearchContextView;